const consumedCouponInfo = []

export default {
  consumedCouponInfo
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-consuming-records/store/state.js